import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Performance',
    [Tab.NewCustomers]: 'Nye restauranter',
    [Tab.CustomerHealth]: 'Kundesundhed',
    [Tab.LiveAndInactive]: 'Live og inaktive',
    [Tab.BillingHealth]: 'Faktureringssundhed',
  },
  labels: {
    sales_manager: 'Salgschef',
  },
  performance_tab: {
    table_columns: {
      name: 'Navn',
      sales_manager: 'Salgschef',
      orders: 'Ordrer',
      sales: 'Salg',
      previous_month_sales: 'Sidste måneds omsætning',
    },
    labels: {
      sales_volume: 'Salgsvolumen:',
      all: 'Alle',
      click_to_sort: 'Klik for at sortere',
      no_data: 'Ingen data',
    },
    toasts: {
      failed_to_load_data: 'Data kunne ikke indlæses',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Navn',
      sales_manager: 'Salgschef',
      orders: 'Ordrer',
      sales: 'Salg',
      days_live: 'Dage live',
      early_performance: 'Tidlig performance',
    },
    labels: {
      click_to_sort: 'Klik for at sortere',
      no_data: 'Ingen data',
      only_with_early_performance: 'Kun med tidlig performance: ',
      early_performance_yes: '✔️ Ja',
      early_performance_no: '✗ Nej',
    },
    toasts: {
      failed_to_load_data: 'Data kunne ikke indlæses',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Salgsniveauer',
      payments_ratio: 'Betalingsforhold',
    },
    dataset_labels: {
      negative: 'Negativ ({{values}})',
      ok: 'OK ({{values}})',
      good: 'God ({{values}})',
      excellent: 'Fremragende ({{values}})',
    },

    companies_preview_modal: {
      title: 'Restaurantoversigt',
      table_columns: {
        name: 'Navn',
        sales_manager: 'Salgschef',
        orders: 'Ordrer',
        sales: 'Salg',
        total_payments: 'Samlede betalinger',
        payments_ratio: 'Betalingsforhold',
      },
      labels: {
        close: 'Luk',
        click_to_sort: 'Klik for at sortere',
        no_data: 'Ingen data',
      },
    },
    toasts: {
      failed_to_load_data: 'Data kunne ikke indlæses',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Live',
      no_orders: 'Ingen ordrer',
      no_conversion: 'Ingen konvertering',
    },
    toasts: {
      failed_to_load_data: 'Data kunne ikke indlæses',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Faktureringstype',
        options: {
          [BillingTypeOptions.Subscription]: 'Abonnement',
          [BillingTypeOptions.Manual]: 'Andet',
        },
      },
      high_risk_only: {
        label: 'Kun højrisikokunder',
      },
    },
    fields: {
      name: 'Navn',
      live_from: 'Live fra',
      billing_mode: {
        title: 'Faktureringskilde',
        options: {
          [BillingMode.Stripe]: 'Betalingsmetode',
          [BillingMode.InternalInvoicing]: 'Salg',
        },
      },
      trial_ends_at: 'Prøveperiodens udløb',
      last_failed_invoice_amount: 'Seneste mislykkede fakturabeløb',
      failed_payments_count: 'Antal mislykkede betalinger',
    },
    tags: {
      is_high_billing_risk_customer: 'Høj faktureringsrisiko',
    },
    toasts: {
      failed_to_load_data: 'Data kunne ikke indlæses',
    },
  },
};
